const state = () => ({
  learningModuleStates: {},
});

const getters = {
  get: (state) => state.learningModuleStates,
  list: (state) => Object.keys(state.learningModuleStates).map(id => state.learningModuleStates[id]),
};

const mutations = {
  set: function(state, learningModuleStates) {
    learningModuleStates.forEach(learningModuleState => {
      state.learningModuleStates[learningModuleState.learningModuleId] = learningModuleState;
    });
  },
};

const actions = {
  send({ dispatch, commit, getters, rootGetters }, params) {
    commit('set', [params]);
    return rootGetters['session/ajax'].post('/learning_module_states', { learningModuleState: params });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
